import { render, staticRenderFns } from "./courseoutline.vue?vue&type=template&id=66fbc80c&scoped=true"
import script from "./courseoutline.vue?vue&type=script&lang=js"
export * from "./courseoutline.vue?vue&type=script&lang=js"
import style0 from "./courseoutline.vue?vue&type=style&index=0&id=66fbc80c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fbc80c",
  null
  
)

export default component.exports